import { FunctionalComponent, h } from 'preact';

import { configGetSettings } from 'common/helper/config/get-settings';
import { BuildingReviewButtonTemplate } from 'common/module/building-review/button/template';
import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { LocationStoreService } from 'common/service/location-store/service';
import { BuildingReviewBundleSettingsInterface } from 'desktop/entry/building-review/bundle/settings.interface';
import { BuildingReviewButtonViewStoreFactory } from 'desktop/module/building-review/button/view-store.factory';

const BuildingReviewButton = preactDynamicComponent(BuildingReviewButtonTemplate);
const element = document.createElement('div');

export const BuildingReviewButtonComponent: FunctionalComponent = (props) => {
  const bundleSettings = configGetSettings<BuildingReviewBundleSettingsInterface>();
  const viewStore = BuildingReviewButtonViewStoreFactory();
  const location = LocationStoreService().getOneById(bundleSettings.location.id);

  viewStore.initialize({
    location,
    element,
    hasAutocomplete: false,
  });

  return <BuildingReviewButton viewStore={viewStore}>{props.children}</BuildingReviewButton>;
};
